import IconFilterContrast from "../../library/v2/Icons/IconFilterContrast";
import IconFilterDefault from "../../library/v2/Icons/IconFilterDefault";
import IconFilterLayout from "../../library/v2/Icons/IconFilterLayout";
import IconFilterSpell from "../../library/v2/Icons/IconFilterSpell";
import CommentStatusFilter,
{ AnnotationStatusFilter, ApprovalsCommentStatusFilter, AIReviewCommentStatusFilter } from "../model/RemarkStatusFilters";

const ApprovalsCommentStatusFilterLabels: Record<ApprovalsCommentStatusFilter, string> = {
    [ApprovalsCommentStatusFilter.Open]: "Open comments",
    [ApprovalsCommentStatusFilter.Pending]: "Pending comments",
    [ApprovalsCommentStatusFilter.Mentioned]: "Mentioned comments",
    [ApprovalsCommentStatusFilter.Resolved]: "Resolved comments",
    [ApprovalsCommentStatusFilter.None]: "None"
};

const AIReviewCommentStatusFilterLabels: Record<AIReviewCommentStatusFilter, string> = {
    [AIReviewCommentStatusFilter.All]: "All",
    [AIReviewCommentStatusFilter.Open]: "Open",
    [AIReviewCommentStatusFilter.Resolved]: "Resolved"
};

const CommentStatusFilterLabels: Record<CommentStatusFilter, string> = {
    [CommentStatusFilter.Open]: "Open comments",
    [CommentStatusFilter.Mentioned]: "Mentioned comments",
    [CommentStatusFilter.Resolved]: "Resolved comments",
    [CommentStatusFilter.None]: "None"
};

const AnnotationStatusFilterLabels: Record<AnnotationStatusFilter, string> = {
    [AnnotationStatusFilter.All]: "All",
    [AnnotationStatusFilter.Mentioned]: "Mentioned",
    [AnnotationStatusFilter.None]: "None"
};

// TODO: Ali -> Create an enum for category names!
function getAIReviewCategoryFilterIcon(category: string) {
    if (category === "layout") {
        return IconFilterLayout;
    }

    if (category === "contrast") {
        return IconFilterContrast;
    }

    if (category === "spelling_and_grammar") {
        return IconFilterSpell;
    }

    return IconFilterDefault;
}

export default CommentStatusFilterLabels;
export {
    AnnotationStatusFilterLabels,
    ApprovalsCommentStatusFilterLabels,
    AIReviewCommentStatusFilterLabels,
    getAIReviewCategoryFilterIcon
};
